import { useTheme } from "../components/Theme";

const ORANGE = "#FF6B2B";

export default function Suspenso() {
  const { theme } = useTheme();
  return (
    <div style={{ minHeight: "100vh", background: theme.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'Inter',sans-serif", padding: 24 }}>
      <div style={{ textAlign: "center", maxWidth: 480 }}>
        <div style={{ fontSize: 64, marginBottom: 20 }}>⚠️</div>
        <h1 style={{ margin: "0 0 12px", fontSize: 28, fontWeight: 800, color: theme.text }}>Acesso Suspenso</h1>
        <p style={{ margin: "0 0 24px", fontSize: 16, color: theme.textMuted, lineHeight: 1.6 }}>
          Sua assinatura está suspensa por falta de pagamento.<br/>
          Entre em contato para regularizar e reativar o acesso.
        </p>
        <div style={{ background: theme.bgCard, border: `1px solid ${theme.border}`, borderRadius: 14, padding: 24, marginBottom: 24 }}>
          <div style={{ fontSize: 14, color: theme.textMuted, marginBottom: 8 }}>Suporte Optimus One</div>
          <a href="mailto:suporte@optimusone.com.br" style={{ color: ORANGE, fontWeight: 700, fontSize: 16, textDecoration: "none" }}>
            suporte@optimusone.com.br
          </a>
        </div>
        <div style={{ fontSize: 13, color: theme.textMuted }}>
          Powered by <span style={{ color: ORANGE, fontWeight: 600 }}>Optimus One</span>
        </div>
      </div>
    </div>
  );
}
